module.exports = __webpack_public_path__ + "media/images/question-mark-icon-4146060d51bda9510d871dbe435b1032.svg";